// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".brand-table-logo {\n  width: 120px;\n  max-height: 120px;\n  object-fit: contain;\n}", "",{"version":3,"sources":["webpack://./src/styles/brand-table.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,iBAAA;EACA,mBAAA;AACF","sourcesContent":[".brand-table-logo {\n  width: 120px;\n  max-height: 120px;\n  object-fit: contain;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
